/**
 * メガメニューをマウスオーバーで開く（PCのみ / snippets/header-mega-menu.liquid とセット）
 *
 * Dawn標準は summary のクリック開閉。ここでは details の open 属性を付け外しするだけなので、
 * Dawn の header-menu カスタム要素（details-disclosure.js）の toggle 処理はそのまま動く。
 *
 * 方針:
 *  - 990px以上（＝Dawnがインラインナビを表示する幅）でのみ有効
 *  - マウス以外（タッチ・ペン）ではホバー処理をせず、従来のタップ開閉を残す
 *  - キーボード操作（Enter/Space、focusout での自動クローズ）は Dawn の挙動を壊さない
 *  - テーマエディタのセクション再描画（shopify:section:load）後も再バインドする
 */
(function () {
  'use strict';

  if (window.khMegaHoverLoaded) return; // 二重読み込み時のリスナー重複を防ぐ
  window.khMegaHoverLoaded = true;

  var DESKTOP = window.matchMedia('(min-width: 990px)');
  var OPEN_DELAY = 80; // ナビ上を通過しただけで開かないための遅延
  var CLOSE_DELAY = 260; // 見出しとパネルの間の余白を横切る間に閉じないための猶予
  var BOUND_FLAG = 'khMegaHoverBound';

  var openTimer = null;
  var closeTimer = null;
  var lastPointerType = 'mouse';

  document.addEventListener(
    'pointerdown',
    function (event) {
      lastPointerType = event.pointerType || 'mouse';
    },
    true
  );

  function currentMenus() {
    var nav = document.querySelector('.header__inline-menu');
    return nav ? Array.prototype.slice.call(nav.querySelectorAll('header-menu')) : [];
  }

  function setOpen(menu, shouldOpen) {
    var details = menu.querySelector('details');
    if (!details) return;
    var summary = details.querySelector('summary');

    if (shouldOpen) {
      if (!details.hasAttribute('open')) details.setAttribute('open', '');
      if (summary) summary.setAttribute('aria-expanded', 'true');
    } else {
      if (details.hasAttribute('open')) details.removeAttribute('open');
      if (summary) summary.setAttribute('aria-expanded', 'false');
    }
  }

  function closeOthers(current) {
    currentMenus().forEach(function (menu) {
      if (menu !== current) setOpen(menu, false);
    });
  }

  function isMouseHover(event) {
    return DESKTOP.matches && (event.pointerType === undefined || event.pointerType === 'mouse');
  }

  function bind(menu) {
    if (menu.dataset[BOUND_FLAG]) return;
    menu.dataset[BOUND_FLAG] = '1';

    menu.addEventListener('pointerenter', function (event) {
      if (!isMouseHover(event)) return;
      clearTimeout(closeTimer);
      clearTimeout(openTimer);
      openTimer = setTimeout(function () {
        closeOthers(menu);
        setOpen(menu, true);
      }, OPEN_DELAY);
    });

    menu.addEventListener('pointerleave', function (event) {
      if (!isMouseHover(event)) return;
      clearTimeout(openTimer);
      closeTimer = setTimeout(function () {
        // キーボード操作中にマウスが外れた場合、フォーカスを隠れたパネルに取り残さない
        if (menu.contains(document.activeElement)) return;
        setOpen(menu, false);
      }, CLOSE_DELAY);
    });

    // ホバーで開いている状態のマウスクリックで閉じてしまわないようにする。
    // キーボードの Enter/Space は click.detail が 0 になるため従来どおり開閉できる。
    var summary = menu.querySelector('summary');
    if (!summary) return;
    summary.addEventListener('click', function (event) {
      var details = menu.querySelector('details');
      if (!DESKTOP.matches || lastPointerType !== 'mouse' || !event.detail) return;
      if (details && details.hasAttribute('open')) event.preventDefault();
    });
  }

  function init() {
    currentMenus().forEach(bind);
  }

  // PC幅から外れたら開きっぱなしを防ぐ
  DESKTOP.addEventListener('change', function (event) {
    if (event.matches) return;
    clearTimeout(openTimer);
    clearTimeout(closeTimer);
    currentMenus().forEach(function (menu) {
      setOpen(menu, false);
    });
  });

  // テーマエディタでヘッダーが再描画されると要素が差し替わるため、再バインドする
  document.addEventListener('shopify:section:load', function (event) {
    if (event.target && event.target.querySelector && event.target.querySelector('.header__inline-menu')) {
      init();
    }
  });

  init();
})();
